/**
 * @generated SignedSource<<0efe02b94091f4d0dc1a75c6493c4a52>>
 * @relayHash 033f72f2f89d6a3cee27b95b20cb38b1
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1956462fb60b399fbc396b3d6c2716b8e6e4da0aef99eee90d3fabfa4cc1aaa1

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateEventWithSlugMutationInput = {
  attendeeLimit?: number | null | undefined;
  description?: string | null | undefined;
  endAt: string;
  name: string;
  ownerId: string;
  ownerType: string;
  startAt: string;
  timeZone: string;
};
export type EventNewContentCreateEventMutation$variables = {
  input: CreateEventWithSlugMutationInput;
};
export type EventNewContentCreateEventMutation$data = {
  readonly createEventWithSlug: {
    readonly event: {
      readonly owner: {
        readonly " $fragmentSpreads": FragmentRefs<"GuildEventsPastCard_guild" | "GuildEventsUpcomingCard_guild" | "UserEventsScreenPastEventsSection_user" | "UserEventsScreenUpcomingEventsSection_user">;
      } | null | undefined;
      readonly prettyUrl: string;
    };
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"EventsScreenList_query">;
    };
  };
};
export type EventNewContentCreateEventMutation = {
  response: EventNewContentCreateEventMutation$data;
  variables: EventNewContentCreateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v5 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "PAST"
},
v6 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_DESC",
      "ID_ASC"
    ]
  },
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExternalUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVenue",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "coverPhoto",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v7/*: any*/),
    {
      "alias": "mobileTransformUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 576
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
    },
    {
      "alias": "desktopTransformUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 200
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v16 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v17 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v18 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v19 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMe",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v25 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v16/*: any*/),
            (v17/*: any*/),
            (v25/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v16/*: any*/),
        (v25/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v29 = {
  "alias": "eventOwner",
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "primaryPhoto",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "fields": [
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/)
                  ],
                  "kind": "ObjectValue",
                  "name": "transform"
                }
              ],
              "kind": "ScalarField",
              "name": "transformUrl",
              "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
            }
          ],
          "storageKey": null
        },
        (v20/*: any*/),
        (v13/*: any*/)
      ],
      "type": "Guild",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v21/*: any*/),
        (v22/*: any*/),
        (v15/*: any*/),
        (v23/*: any*/),
        (v13/*: any*/),
        (v24/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/)
      ],
      "type": "User",
      "abstractKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v31 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v13/*: any*/),
  (v24/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v7/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v33 = {
  "alias": "attendeesByRelevance",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "ATTENDING_IN_PERSON",
            "ATTENDING_VIRTUAL",
            "WAITING_IN_PERSON",
            "WAITING_VIRTUAL"
          ]
        }
      }
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 8
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendeesByRelevance",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendeesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventAttendee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v31/*: any*/),
              "storageKey": null
            },
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
},
v34 = [
  (v30/*: any*/)
],
v35 = {
  "alias": "attendingCount",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "ATTENDING_IN_PERSON",
            "ATTENDING_VIRTUAL"
          ]
        }
      }
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendees",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
},
v36 = {
  "alias": "waitingCount",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "WAITING_IN_PERSON",
            "WAITING_VIRTUAL"
          ]
        }
      }
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendees",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "EventTicketingTiersConnection",
  "kind": "LinkedField",
  "name": "eventTicketingTiers",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "EventAttendee",
  "kind": "LinkedField",
  "name": "myAttendance",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendeeTicketPurchase",
      "kind": "LinkedField",
      "name": "ticketPurchase",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stripePaymentIntentStatus",
          "storageKey": null
        },
        (v7/*: any*/),
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v15/*: any*/),
        (v20/*: any*/)
      ],
      "type": "Guild",
      "abstractKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v44 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v47 = {
  "alias": "eventItemPresentations",
  "args": [
    (v44/*: any*/)
  ],
  "concreteType": "PresentationsConnection",
  "kind": "LinkedField",
  "name": "presentations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PresentationsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Presentation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v13/*: any*/),
            (v45/*: any*/),
            (v46/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "presenter",
              "plural": false,
              "selections": (v31/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "transform",
                  "value": {
                    "dpr": 3,
                    "fo": "auto",
                    "h": 24,
                    "w": 24
                  }
                }
              ],
              "kind": "ScalarField",
              "name": "guestPresenterAvatarUrl",
              "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":24,\"w\":24})"
            },
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  "timeSelection",
  "orderBy"
],
v50 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "UPCOMING"
},
v51 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_ASC",
      "ID_ASC"
    ]
  },
  (v50/*: any*/)
],
v52 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v32/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          (v8/*: any*/),
          (v2/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v14/*: any*/),
          (v29/*: any*/),
          (v33/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v13/*: any*/),
          (v38/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v48/*: any*/)
],
v53 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v54 = {
  "alias": "legacyDefaultAvatarUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "transform",
      "value": {
        "dpr": 3,
        "fo": "auto",
        "h": 48,
        "w": 48
      }
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":48,\"w\":48})"
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v58 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v55/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v24/*: any*/),
              (v54/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v30/*: any*/)
],
v59 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v2/*: any*/),
          (v9/*: any*/),
          (v38/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v20/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v23/*: any*/),
                  (v7/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventAttendee",
            "kind": "LinkedField",
            "name": "myAttendance",
            "plural": false,
            "selections": [
              (v39/*: any*/),
              (v40/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "eventCardPresentations",
            "args": [
              (v4/*: any*/),
              (v44/*: any*/)
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "fo": "auto",
                              "h": 32,
                              "w": 32
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "guestPresenterAvatarUrl",
                        "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":32,\"w\":32})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "presenter",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v13/*: any*/),
                          (v24/*: any*/),
                          (v54/*: any*/),
                          (v56/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
          },
          {
            "alias": "attendingInPerson",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "ATTENDING_IN_PERSON"
                }
              },
              (v57/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": (v58/*: any*/),
            "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:5)"
          },
          {
            "alias": "attendingVirtually",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "ATTENDING_VIRTUAL"
                }
              },
              (v57/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": (v58/*: any*/),
            "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:5)"
          },
          {
            "alias": "waiting",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "WAITING_IN_PERSON"
                }
              },
              (v57/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v13/*: any*/),
                          (v24/*: any*/),
                          (v54/*: any*/),
                          (v56/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v30/*: any*/)
            ],
            "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"WAITING_IN_PERSON\"},first:5)"
          },
          (v12/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v32/*: any*/)
    ],
    "storageKey": null
  },
  (v48/*: any*/)
],
v60 = [
  "timeSelection"
],
v61 = [
  (v4/*: any*/),
  (v50/*: any*/)
],
v62 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": [
        {
          "not": {
            "metadata": {
              "containsKey": "meetupEventID"
            }
          }
        },
        {
          "allowGlobalListing": {
            "equalTo": true
          }
        }
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v50/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventNewContentCreateEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEventWithSlugMutationPayload",
        "kind": "LinkedField",
        "name": "createEventWithSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GuildEventsPastCard_guild"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GuildEventsUpcomingCard_guild"
                      }
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserEventsScreenPastEventsSection_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserEventsScreenUpcomingEventsSection_user"
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventsScreenList_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventNewContentCreateEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEventWithSlugMutationPayload",
        "kind": "LinkedField",
        "name": "createEventWithSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "pastEvents",
                        "args": (v6/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventsByTimeSelection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v2/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v14/*: any*/),
                                  (v29/*: any*/),
                                  (v33/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v13/*: any*/),
                                  (v38/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v47/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v32/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v48/*: any*/)
                        ],
                        "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
                      },
                      {
                        "alias": "pastEvents",
                        "args": (v6/*: any*/),
                        "filters": (v49/*: any*/),
                        "handle": "connection",
                        "key": "GuildEventsPastCard_guild_pastEvents",
                        "kind": "LinkedHandle",
                        "name": "eventsByTimeSelection"
                      },
                      (v7/*: any*/),
                      {
                        "alias": "upcomingEvents",
                        "args": (v51/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventsByTimeSelection",
                        "plural": false,
                        "selections": (v52/*: any*/),
                        "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
                      },
                      {
                        "alias": "upcomingEvents",
                        "args": (v51/*: any*/),
                        "filters": (v49/*: any*/),
                        "handle": "connection",
                        "key": "GuildEventsUpcomingCard_guild_upcomingEvents",
                        "kind": "LinkedHandle",
                        "name": "eventsByTimeSelection"
                      }
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "pastEvents",
                        "args": (v53/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventAttendance",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": "eventAttendance(first:3,timeSelection:\"PAST\")"
                      },
                      {
                        "alias": "pastEvents",
                        "args": (v53/*: any*/),
                        "filters": (v60/*: any*/),
                        "handle": "connection",
                        "key": "UserEventsScreenPastEventsSection_guild_pastEvents",
                        "kind": "LinkedHandle",
                        "name": "eventAttendance"
                      },
                      (v7/*: any*/),
                      {
                        "alias": "upcomingEvents",
                        "args": (v61/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventAttendance",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": "eventAttendance(first:3,timeSelection:\"UPCOMING\")"
                      },
                      {
                        "alias": "upcomingEvents",
                        "args": (v61/*: any*/),
                        "filters": (v60/*: any*/),
                        "handle": "connection",
                        "key": "UserEventsScreenUpcomingEventsSection_guild_upcomingEvents",
                        "kind": "LinkedHandle",
                        "name": "eventAttendance"
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": "upcomingEvents",
                "args": (v62/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v52/*: any*/),
                "storageKey": "eventsByTimeSelection(filter:{\"and\":[{\"not\":{\"metadata\":{\"containsKey\":\"meetupEventID\"}}},{\"allowGlobalListing\":{\"equalTo\":true}}]},first:10,timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "upcomingEvents",
                "args": (v62/*: any*/),
                "filters": [
                  "timeSelection",
                  "filter"
                ],
                "handle": "connection",
                "key": "EventsScreenList_query_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "eventsByTimeSelection"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "authorizationLevel",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1956462fb60b399fbc396b3d6c2716b8e6e4da0aef99eee90d3fabfa4cc1aaa1",
    "metadata": {},
    "name": "EventNewContentCreateEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "81d81f866ae85e8d1e756546088eb5f7";

export default node;
